import { camelizeKeys } from "humps";
import { Product } from "~/common/props/orchestrator";
import { normalizeUrl } from "@commons-monorepo/index";
import { getApiUrl, getEnvVar } from "@commons-monorepo/index";
import { ReviewItem } from "~/components/Reviews/reviews.types";

export const setFavorite = (product: Product) => {
  const token = localStorage.getItem("accessToken");
  return fetch(
    `${getApiUrl()}/api/ms/user/customer-detail/favorites/${product.ownerId}`,
    {
      method: product.customerFavorite ? "PUT" : "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token ? `Bearer ${token.replace(/['"]+/g, "")}` : "",
      } as HeadersInit,
      body: JSON.stringify([product.id]),
    },
  ).then((response) => response.json());
};

export const fetchProductsRecomend = (storeId: string) => {
  return fetch(
    `${getApiUrl()}/api/ms/orchestrator/catalogue/${normalizeUrl(storeId)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "api-key-sumer": getEnvVar("PUBLIC_API_KEY"),
        "X-API-VERSION": "2",
      } as HeadersInit,
    },
  )
    .then((res) => res.json())
    .then((res) => camelizeKeys(res))
    .then((res) => res.products);
};

export const fetchReviews = (storeId: string, productId: string) => {
  return fetch(
    `${getApiUrl()}/api/ms/order/store/${storeId}/statistic/${productId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "api-key-sumer": getEnvVar("PUBLIC_API_KEY"),
      } as HeadersInit,
    },
  ).then(
    async (response) => camelizeKeys(await response.json()) as ReviewItem[],
  );
};
